/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The rejection code of an RTP transaction that caused the bank account status to change.
 *
 * @remarks
 *
 * - AC03: Account Invalid
 * - AC04: Account Closed
 * - AC06: Account Blocked
 * - AC14: Creditor Account Type Invalid
 * - AG01: Transactions Forbidden On Account
 * - AG03: Transaction Type Not Supported
 * - MD07: Customer Deceased
 */
export const RTPRejectionCode = {
  Ac03: "AC03",
  Ac04: "AC04",
  Ac06: "AC06",
  Ac14: "AC14",
  Ag01: "AG01",
  Ag03: "AG03",
  Md07: "MD07",
} as const;
/**
 * The rejection code of an RTP transaction that caused the bank account status to change.
 *
 * @remarks
 *
 * - AC03: Account Invalid
 * - AC04: Account Closed
 * - AC06: Account Blocked
 * - AC14: Creditor Account Type Invalid
 * - AG01: Transactions Forbidden On Account
 * - AG03: Transaction Type Not Supported
 * - MD07: Customer Deceased
 */
export type RTPRejectionCode = ClosedEnum<typeof RTPRejectionCode>;

/** @internal */
export const RTPRejectionCode$inboundSchema: z.ZodNativeEnum<
  typeof RTPRejectionCode
> = z.nativeEnum(RTPRejectionCode);
/** @internal */
export const RTPRejectionCode$outboundSchema: z.ZodNativeEnum<
  typeof RTPRejectionCode
> = RTPRejectionCode$inboundSchema;
